var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.932,
    height: 139.932,
    viewBox: "0 0 37.024 37.024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter13419",
    width: 1.041,
    height: 1.088,
    x: -0.021,
    y: -0.044,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148.454 -66.14)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    strokeLinecap: "round",
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.024,
    height: 37.024,
    x: 148.454,
    y: 66.139,
    fill: "none",
    stroke: "none",
    strokeWidth: 0.754,
    opacity: 1,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#242424",
    strokeDasharray: "none",
    transform: "translate(-2.113 1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.774,
    d: "M158.028 76.3a3.296 3.296 0 00-2.935 1.802h-.622c-.822 0-1.485.662-1.485 1.485 0 .823.663 1.485 1.485 1.485h.61a3.296 3.296 0 002.947 1.822 3.296 3.296 0 002.946-1.822h23.413c.823 0 1.485-.662 1.485-1.485 0-.823-.662-1.485-1.485-1.485h-23.422a3.296 3.296 0 00-2.937-1.801zm16.11 8.846a3.296 3.296 0 00-2.947 1.821h-16.72c-.822 0-1.485.663-1.485 1.485 0 .823.663 1.486 1.485 1.486h16.73a3.296 3.296 0 002.936 1.8 3.296 3.296 0 002.936-1.8h7.314c.823 0 1.485-.663 1.485-1.486 0-.822-.662-1.485-1.485-1.485h-7.302a3.296 3.296 0 00-2.948-1.821z",
    filter: "url(#filter13419)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#aec6dd",
    strokeWidth: 0.672,
    transform: "matrix(1.15232 0 0 1.15232 -13.864 -11.112)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.539,
    height: 2.578,
    x: 143.936,
    y: 76.313,
    fill: "#f8f9fa",
    opacity: 1,
    ry: 1.289
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.311,
    cy: 77.61,
    r: 2.861,
    fill: "#3b69a5",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.539,
    height: 2.578,
    x: -172.475,
    y: 84.006,
    fill: "#aec6dd",
    opacity: 1,
    ry: 1.289,
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -162.291,
    cy: 85.286,
    r: 2.861,
    fill: "#f8f9fa",
    opacity: 1,
    transform: "scale(-1 1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDraft);
export default __webpack_public_path__ + "static/media/search_draft.1778d1c4a861bca552096b42ebb3733b.svg";
export { ForwardRef as ReactComponent };